export default "__VITE_ASSET__BxGiD8iI__"